webpackJsonp([1],{

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(66)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(71),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_1_vue_select___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dot__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ExtendedVueSelect__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ExtendedVueSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ExtendedVueSelect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var TWEEN = __webpack_require__(32);
var BezierEasing = __webpack_require__(39);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    dot: __WEBPACK_IMPORTED_MODULE_1__components_dot___default.a,
    vExselect: __WEBPACK_IMPORTED_MODULE_2__components_ExtendedVueSelect___default.a
  },
  data: function data() {
    return {
      startedSim: false,
      reactionVariable: 'Control',
      runReactionLabel: 'Run Reaction',
      cupBackground: 'background-image: url(static/beaker-default.png)',
      increaseOrDecrease: null,
      step: 1,
      // "going" vars, for the line graphs
      ctrlGoing: { x: 25, y: 275 },
      going: { x: 25, y: 275 },
      varGoing: { x: 25, y: 275 },
      // default start and end positions of the line
      // plus the end positions for faster/slower reactions
      startGo: { x: 25, y: 275 },
      end: { x: 245, y: 45 },
      fastEnd: { x: 165, y: 45 },
      slowEnd: { x: 245, y: 165 },
      reactionTime: 5000,
      startSpinning: false,
      dots: []
    };
  },
  created: function created() {
    this.defaultDots();
  },
  computed: {
    showButtons: function showButtons() {
      if (this.reactionVariable === 'Control' || this.reactionVariable === 'Catalyst' || this.reactionVariable === null) {
        return false;
      } else {
        return true;
      }
    },
    showDrop: function showDrop() {
      if (this.reactionVariable === 'Catalyst') {
        return true;
      } else {
        return false;
      }
    },
    canRunReaction: function canRunReaction() {
      if (this.reactionVariable === 'Catalyst' || this.reactionVariable === 'Control') {
        return true;
      } else {
        if (this.increaseOrDecrease !== null) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  watch: {
    reactionVariable: function reactionVariable(newV, oldV) {
      if (newV !== oldV) {
        this.resetReaction();
      }
    },
    going: function going(newV, oldV) {
      function animate() {
        if (TWEEN.update()) {
          requestAnimationFrame(animate);
        }
      }
      if (this.step === 2) {
        new TWEEN.Tween(this.going).to(this.end, 5000).start();

        animate();
      }
    },
    ctrlGoing: function ctrlGoing() {
      function animate() {
        if (TWEEN.update()) {
          requestAnimationFrame(animate);
        }
      }

      new TWEEN.Tween(this.ctrlGoing).to(this.end, 5000).start();

      animate();
    },
    varGoing: function varGoing() {
      function animate() {
        if (TWEEN.update()) {
          requestAnimationFrame(animate);
        }
      }
      if (this.step === 2) {
        var whichEnd;
        if (this.increaseOrDecrease === 'increase') {
          whichEnd = this.fastEnd;
        } else {
          whichEnd = this.slowEnd;
        }

        var rv = this.reactionVariable;
        if (rv === 'Catalyst') {
          whichEnd = this.fastEnd;
        } else if (rv === 'Control') {
          whichEnd = this.varGoing;
        }

        new TWEEN.Tween(this.varGoing).to(whichEnd, this.reactionTime).start();

        animate();
      }
    }
  },
  methods: {
    runControlReaction: function runControlReaction() {
      this.ctrlGoing = { x: this.startGo.x, y: this.startGo.y };
      this.startedSim = 'kinda';
      this.startSpinning = 'spin';

      this.defaultDotsRun();
    },
    defaultDots: function defaultDots() {
      this.cupBackground = 'background-image: url(static/beaker-default.png)';
      this.dots = [{ cx: 260, cy: 200, r: 10, fill: '#E01100' }, { cx: 260, cy: 230, r: 10, fill: '#E01100' }, { cx: 260, cy: 260, r: 10, fill: '#E01100' }, { cx: 260, cy: 290, r: 10, fill: '#E01100' }, { cx: 260, cy: 320, r: 10, fill: '#E01100' }, { cx: 160, cy: 200, r: 10, fill: '#0031DF' }, { cx: 160, cy: 230, r: 10, fill: '#0031DF' }, { cx: 160, cy: 260, r: 10, fill: '#0031DF' }, { cx: 160, cy: 290, r: 10, fill: '#0031DF' }, { cx: 160, cy: 320, r: 10, fill: '#0031DF' }];
    },
    increaseConcentrationDots: function increaseConcentrationDots() {
      this.cupBackground = 'background-image: url(static/beaker-default.png)';
      this.dots = [{ cx: 230, cy: 200, r: 10, fill: '#E01100' }, { cx: 230, cy: 230, r: 10, fill: '#E01100' }, { cx: 230, cy: 260, r: 10, fill: '#E01100' }, { cx: 230, cy: 290, r: 10, fill: '#E01100' }, { cx: 230, cy: 320, r: 10, fill: '#E01100' }, { cx: 270, cy: 200, r: 10, fill: '#E01100' }, { cx: 270, cy: 230, r: 10, fill: '#E01100' }, { cx: 270, cy: 260, r: 10, fill: '#E01100' }, { cx: 270, cy: 290, r: 10, fill: '#E01100' }, { cx: 270, cy: 320, r: 10, fill: '#E01100' }, { cx: 150, cy: 200, r: 10, fill: '#0031DF' }, { cx: 150, cy: 230, r: 10, fill: '#0031DF' }, { cx: 150, cy: 260, r: 10, fill: '#0031DF' }, { cx: 150, cy: 290, r: 10, fill: '#0031DF' }, { cx: 150, cy: 320, r: 10, fill: '#0031DF' }, { cx: 190, cy: 200, r: 10, fill: '#0031DF' }, { cx: 190, cy: 230, r: 10, fill: '#0031DF' }, { cx: 190, cy: 260, r: 10, fill: '#0031DF' }, { cx: 190, cy: 290, r: 10, fill: '#0031DF' }, { cx: 190, cy: 320, r: 10, fill: '#0031DF' }];
    },
    decreaseConcentrationDots: function decreaseConcentrationDots() {
      this.cupBackground = 'background-image: url(static/beaker-default.png)';
      this.dots = [{ cx: 240, cy: 220, r: 10, fill: '#E01100' }, { cx: 240, cy: 260, r: 10, fill: '#E01100' }, { cx: 240, cy: 300, r: 10, fill: '#E01100' }, { cx: 180, cy: 220, r: 10, fill: '#0031DF' }, { cx: 180, cy: 260, r: 10, fill: '#0031DF' }, { cx: 180, cy: 300, r: 10, fill: '#0031DF' }];
    },
    increaseSurfaceAreaDots: function increaseSurfaceAreaDots() {
      this.cupBackground = 'background-image: url(static/beaker-high-sa.png)';
      this.dots = [{ cx: 265, cy: 150, r: 10, fill: '#E01100' }, { cx: 265, cy: 195, r: 10, fill: '#E01100' }, { cx: 265, cy: 240, r: 10, fill: '#E01100' }, { cx: 265, cy: 285, r: 10, fill: '#E01100' }, { cx: 265, cy: 330, r: 10, fill: '#E01100' }, { cx: 155, cy: 150, r: 10, fill: '#0031DF' }, { cx: 155, cy: 195, r: 10, fill: '#0031DF' }, { cx: 155, cy: 240, r: 10, fill: '#0031DF' }, { cx: 155, cy: 285, r: 10, fill: '#0031DF' }, { cx: 155, cy: 330, r: 10, fill: '#0031DF' }];
    },
    decreaseSurfaceAreaDots: function decreaseSurfaceAreaDots() {
      this.cupBackground = 'background-image: url(static/beaker-high-sa.png)';
      this.dots = [{ cx: 240, cy: 328, r: 10, fill: '#E01100' }, { cx: 226, cy: 300, r: 10, fill: '#E01100' }, { cx: 200, cy: 296, r: 10, fill: '#E01100' }, { cx: 176, cy: 303, r: 10, fill: '#E01100' }, { cx: 185, cy: 330, r: 10, fill: '#E01100' }, { cx: 210, cy: 320, r: 10, fill: '#0031DF' }, { cx: 160, cy: 281, r: 10, fill: '#0031DF' }, { cx: 142, cy: 299, r: 10, fill: '#0031DF' }, { cx: 159, cy: 322, r: 10, fill: '#0031DF' }, { cx: 138, cy: 330, r: 10, fill: '#0031DF' }];
    },
    generatePositionsArray: function generatePositionsArray(maxX, maxY, safeRadius, irregularity) {
      var positionsArray = [];
      var r;
      var c;
      var rows;
      var columns;
      // count the amount of rows and columns
      rows = Math.floor(maxY / safeRadius);
      columns = Math.floor(maxX / safeRadius);
      // loop through rows
      for (r = 1; r <= rows; r += 1) {
        // loop through columns
        for (c = 1; c <= columns; c += 1) {
          // populate array with point object
          positionsArray.push({
            x: Math.round(maxX * c / columns) + this.getRandomInt(irregularity * -1, irregularity),
            y: Math.round(maxY * r / rows) + this.getRandomInt(irregularity * -2, irregularity * 2)
          });
        }
      }
      // return array
      return positionsArray;
    },
    getRandomPosition: function getRandomPosition(array, removeTaken) {
      var randomIndex;
      var coordinates;
      // get random index
      randomIndex = this.getRandomInt(0, array.length - 1);
      // get random item from array
      coordinates = array[randomIndex];
      // check if remove taken
      if (removeTaken) {
        // remove element from array
        array.splice(randomIndex, 1);
      }
      // return position
      return coordinates;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
    getRandomNFromArr: function getRandomNFromArr(arr, n) {
      n = Math.ceil(n);
      var result = new Array(n);
      var len = arr.length;
      var taken = new Array(len);
      if (n > len) {
        return arr;
      }
      while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
      }
      return result;
    },
    map: function map(num, inMin, inMax, outMin, outMax) {
      var r = (num - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
      if (isNaN(r)) {
        return outMax;
      }
      return r;
    },
    defaultDotsRun: function defaultDotsRun() {
      // set new random x/y within the bounds for the dots to move to
      var that = this;
      var thedots = this.dots;
      var posYOff = this.reactionVariable === 'Surface Area' ? 140 : 190;
      var safeSpace = 25;
      if (this.reactionVariable === 'Concentration') {
        safeSpace = 20;
      }
      var positions = this.generatePositionsArray(120, 310 - posYOff, safeSpace, 3);
      if (positions.length <= thedots.length) {
        var morePositions = this.generatePositionsArray(120, 310 - posYOff, safeSpace, 3);
        positions = positions.concat(morePositions);
      }

      thedots.forEach(function (dot, index) {
        dot.origcx = dot.cx;
        dot.origcy = dot.cy;
        var pos;
        var posYOff = that.reactionVariable === 'Surface Area' ? 140 : 190;
        if (index < thedots.length / 2) {
          dot.newfill = '#622170';
          pos = that.getRandomPosition(positions, true);
          dot.newcx = pos.x + 150;
          dot.newcy = pos.y + posYOff;
        } else {
          dot.newfill = '#622170';
          pos = that.getRandomPosition(positions, true);
          dot.newcx = pos.x + 150;
          dot.newcy = pos.y + posYOff;
          // dot.newcx = thedots[index - (thedots.length / 2)].newcx
          // dot.newcy = thedots[index - (thedots.length / 2)].newcy
        }
      });

      // get random half to fade
      // iterators are weird
      var thedotsindexes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(thedots.keys()));
      var halfdots = this.getRandomNFromArr(thedotsindexes, thedots.length / 2);

      // loop through the dots one more time and animate them from old xy to new xy and wiggle x
      thedots.forEach(function (dot, index) {
        function animate(time) {
          requestAnimationFrame(animate);
          TWEEN.update(time);
        }
        requestAnimationFrame(animate);

        var coords = { x: dot.origcx, y: dot.origcy };
        var steps = that.reactionTime / (thedots.length / 2); // time between steps
        steps = steps / that.reactionTime; // steps are this out of 1

        new TWEEN.Tween(coords).to({ x: dot.newcx, y: dot.newcy }, that.reactionTime).easing(that.createWigglyEasing()).onUpdate(function () {
          var xw = that.map(coords.x, dot.origcx, dot.newcx, 0, thedots.length);
          var yw = that.map(coords.y, dot.origcy, dot.newcy, 0, thedots.length);
          var xwig = Math.sin(xw) * (that.reactionTime / 1000);
          var ywig = Math.sin(yw) * (that.reactionTime / 2000);
          dot.cx = coords.x + xwig;
          dot.cy = coords.y + ywig;
          if (halfdots.includes(index)) {
            var hindex = halfdots.indexOf(index) + 1;
            if (thedots.length < 10) {
              xw = xw * 2;
            }
            if (hindex * steps * 10 < xw) {
              dot.fill = dot.newfill;
            }
          } else {
            dot.opacity = (1 - xw * (1 / thedots.length)) * 0.6;
            dot.xo = dot.opacity;
          }
        }).onComplete(function () {
          dot.opacity = dot.xo;
        }).start();
      });
    },
    decreasedDotsRun: function decreasedDotsRun() {
      // set new random x/y within the bounds for the dots to move to
      var that = this;
      var thedots = this.dots;
      var posYOff = this.reactionVariable === 'Surface Area' ? 140 : 190;
      var safeSpace = 25;
      var positions = this.generatePositionsArray(120, 310 - posYOff, safeSpace, 3);
      if (positions.length <= thedots.length) {
        var morePositions = this.generatePositionsArray(120, 310 - posYOff, safeSpace, 3);
        positions = positions.concat(morePositions);
      }

      thedots.forEach(function (dot, index) {
        dot.origcx = dot.cx;
        dot.origcy = dot.cy;
        var pos;
        var posYOff = that.reactionVariable === 'Surface Area' ? 140 : 190;
        if (index < thedots.length / 2) {
          dot.newfill = '#622170';
          pos = that.getRandomPosition(positions, true);
          dot.newcx = pos.x + 150;
          dot.newcy = pos.y + posYOff;
        } else {
          dot.newfill = '#622170';
          pos = that.getRandomPosition(positions, true);
          dot.newcx = pos.x + 150;
          dot.newcy = pos.y + posYOff;
          // dot.newcx = thedots[index - (thedots.length / 2)].newcx
          // dot.newcy = thedots[index - (thedots.length / 2)].newcy
        }
      });

      // get random half to fade
      // iterators are weird
      // var thedotsindexes = [...thedots.keys()]
      // hard code these instead!
      var halfdots = [0, 1, 2, 3, 5, 6, 7, 8];
      var halfhalf = [0, 5];

      // loop through the dots one more time and animate them from old xy to new xy and wiggle x
      thedots.forEach(function (dot, index) {
        function animate(time) {
          requestAnimationFrame(animate);
          TWEEN.update(time);
        }
        requestAnimationFrame(animate);

        var coords = { x: dot.origcx, y: dot.origcy };
        var steps = that.reactionTime / (thedots.length / 2); // time between steps
        steps = steps / that.reactionTime; // steps are this out of 1

        new TWEEN.Tween(coords).to({ x: dot.newcx, y: dot.newcy }, that.reactionTime).easing(that.createWigglyEasing()).onUpdate(function () {
          var xw = that.map(coords.x, dot.origcx, dot.newcx, 0, thedots.length);
          var yw = that.map(coords.y, dot.origcy, dot.newcy, 0, thedots.length);
          var xwig = Math.sin(xw) * (that.reactionTime / 1000);
          var ywig = Math.sin(yw) * (that.reactionTime / 2000);
          dot.cx = coords.x + xwig;
          dot.cy = coords.y + ywig;
          if (halfdots.includes(index)) {
            var hindex = halfdots.indexOf(index) + 1;
            if (hindex * steps * 10 < xw) {
              if (halfhalf.includes(halfdots[hindex - 1])) {
                dot.fill = dot.newfill;
              }
            }
          } else {
            dot.opacity = (1 - xw * 0.1) * 0.6;
            dot.xo = dot.opacity;
          }
        }).onComplete(function () {
          dot.opacity = dot.xo;
        }).start();
      });
    },
    createNoisyEasing: function createNoisyEasing(randomProportion, easingFunction) {
      var normalProportion = 1.0 - randomProportion;
      return function (k) {
        return randomProportion * Math.random() + normalProportion * easingFunction(k);
      };
    },
    createWigglyEasing: function createWigglyEasing() {
      var ease = BezierEasing(0.68, 0.76, 0.71, 1.1);
      return function (k) {
        return ease(k);
      };
    },
    mixItUp: function mixItUp() {
      this.startedSim = true;
      this.startSpinning = false;
      this.defaultDots();
    },
    runReaction: function runReaction() {
      if (this.step === 1) {
        this.runReactionLabel = 'Start Over &rarr;';
        this.step++;

        this.startSpinning = 'spin';
        var rv = this.reactionVariable;

        if (this.increaseOrDecrease === 'increase') {
          this.reactionTime = 2500;
        }

        if (rv === 'Catalyst') {
          this.reactionTime = 2500;
          this.defaultDotsRun();
        } else if (rv === 'Concentration') {
          this.defaultDotsRun();
        } else if (rv === 'Surface Area') {
          if (this.increaseOrDecrease === 'increase') {
            this.defaultDotsRun();
          } else if (this.increaseOrDecrease === 'decrease') {
            this.decreasedDotsRun();
          }
        } else if (rv === 'Temperature') {
          if (this.increaseOrDecrease === 'increase') {
            this.defaultDotsRun();
          } else if (this.increaseOrDecrease === 'decrease') {
            this.decreasedDotsRun();
          }
        } else if (rv === 'Control') {
          this.defaultDotsRun();
          this.going = { x: this.startGo.x, y: this.startGo.y };
        }
        this.varGoing = { x: this.startGo.x, y: this.startGo.y };
      } else if (this.step === 2) {
        this.resetReaction();
      }
    },
    resetReaction: function resetReaction() {
      var iOrD = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.step = 1;
      this.runReactionLabel = 'Run Reaction';
      this.increaseOrDecrease = iOrD;
      this.startSpinning = false;
      this.reactionTime = 5000;

      var rv = this.reactionVariable;
      if (rv === 'Catalyst') {
        this.defaultDots();
        this.going = { x: this.end.x, y: this.end.y };
      } else if (rv === 'Concentration') {
        this.defaultDots();
        this.going = { x: this.end.x, y: this.end.y };
        if (this.increaseOrDecrease === 'increase') {
          this.increaseConcentrationDots();
        } else if (this.increaseOrDecrease === 'decrease') {
          this.decreaseConcentrationDots();
        }
      } else if (rv === 'Surface Area') {
        this.defaultDots();
        this.going = { x: this.end.x, y: this.end.y };
        this.cupBackground = 'background-image: url(static/beaker-high-sa.png)';
        if (this.increaseOrDecrease === 'increase') {
          this.increaseSurfaceAreaDots();
        } else if (this.increaseOrDecrease === 'decrease') {
          this.decreaseSurfaceAreaDots();
        }
      } else if (rv === 'Temperature') {
        this.defaultDots();
        this.going = { x: this.end.x, y: this.end.y };
      } else if (rv === 'Control') {
        this.defaultDots();
        this.going = { x: this.startGo.x - 1, y: this.startGo.y + 1 };
      }
      this.varGoing = { x: this.startGo.x - 1, y: this.startGo.y + 1 };
    },
    increase: function increase() {
      if (this.increaseOrDecrease === 'increase') {
        this.increaseOrDecrease = null;
      } else {
        this.increaseOrDecrease = 'increase';
      }
      this.resetReaction(this.increaseOrDecrease);
    },
    decrease: function decrease() {
      if (this.increaseOrDecrease === 'decrease') {
        this.increaseOrDecrease = null;
      } else {
        this.increaseOrDecrease = 'decrease';
      }
      this.resetReaction(this.increaseOrDecrease);
    }
  }
});

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_select__);

// ExtendedVueSelect.vue
// https://github.com/sagalbot/vue-select/issues/180
// https://github.com/sagalbot/vue-select/pull/194


/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_select___default.a,
  methods: {
    /**
     * Select a given option.
     * @param  {Object|String} option
     * @return {void}
     */
    select: function select(option) {
      if (this.isOptionSelected(option)) {
        if (this.toggleSelectOption) {
          this.deselect(option);
        }
      } else {
        if (this.taggable && !this.optionExists(option)) {
          option = this.createOption(option);
        }
        if (this.multiple && !this.mutableValue) {
          this.mutableValue = [option];
        } else if (this.multiple) {
          this.mutableValue.push(option);
        } else {
          this.mutableValue = option;
        }
      }
      this.onAfterSelect(option);
    },

    /**
     * Toggle the visibility of the dropdown menu.
     * @param  {Event} e
     * @return {void}
     */
    toggleDropdown: function toggleDropdown(e) {
      if (!this.disabled) {
        if (e.target === this.$refs.openIndicator || e.target === this.$refs.search || e.target === this.$refs.toggle || e.target === this.$el) {
          if (this.open) {
            this.$refs.search.blur(); // dropdown will close on blur
          } else {
            this.open = true;
            this.$refs.search.focus();
          }
        }
      }
    }
  },
  props: {
    /**
     * Enable/Disable deselect the option by double select it
     * @type {Boolean}
     */
    toggleSelectOption: {
      type: Boolean,
      default: false
    },
    /**
     * Enable/Disable
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dot',
  props: ['cx', 'cy', 'r', 'fill', 'opacity']
});

/***/ }),

/***/ 66:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(35),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 71:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "cup",
    style: (_vm.cupBackground)
  }, [_c('img', {
    staticClass: "catalyst",
    class: _vm.showDrop == true ? 'show' : '',
    attrs: {
      "src": "static/eye-dropper.png",
      "alt": "",
      "width": "400",
      "height": "400"
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "dots",
    attrs: {
      "width": "400",
      "height": "400",
      "viewBox": "0 0 400 400"
    }
  }, [_c('g', {
    attrs: {
      "id": "dots"
    }
  }, [_vm._l((_vm.dots), function(dot) {
    return [_c('dot', {
      attrs: {
        "cx": dot.cx,
        "cy": dot.cy,
        "r": dot.r,
        "fill": dot.fill,
        "opacity": !isNaN(dot.opacity) ? dot.opacity : 0.6
      }
    })]
  })], 2)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedSim == false),
      expression: "startedSim == false"
    }],
    key: "intro",
    staticClass: "intro"
  }, [_c('h1', [_vm._v("Reaction Rates")]), _vm._v(" "), _c('p', [_vm._v("Examine a chemical reaction and then investigate variables that can affect its rate.")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.runControlReaction
    }
  }, [_vm._v("Run Reaction")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedSim == 'kinda'),
      expression: "startedSim == 'kinda'"
    }],
    key: "simstart",
    staticClass: "simstart"
  }, [_c('svg', {
    staticClass: "graph",
    attrs: {
      "width": "300",
      "height": "300",
      "viewBox": "0 0 300 300"
    }
  }, [_c('g', {
    attrs: {
      "id": "ctrlGraph"
    }
  }, [_c('g', {
    attrs: {
      "id": "ctrlLabelsnlines"
    }
  }, [_c('text', {
    staticStyle: {
      "transform": "rotate(-90deg)"
    },
    attrs: {
      "x": "-200",
      "y": "10",
      "font-family": "proxima-nova",
      "font-size": "13",
      "fill": "#797d82"
    }
  }, [_vm._v("Amount of Product")]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "140",
      "y": "300",
      "font-family": "proxima-nova",
      "font-size": "13",
      "fill": "#797d82"
    }
  }, [_vm._v("Time")]), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "25",
      "y1": "275",
      "x2": "275",
      "y2": "275",
      "stroke": "#797d82"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "25",
      "y1": "25",
      "x2": "25",
      "y2": "275",
      "stroke": "#797d82"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clock",
    attrs: {
      "cx": "278",
      "cy": "32",
      "r": "21",
      "stroke": "#ccc",
      "stroke-width": "1.8",
      "fill": "#ffffff"
    }
  }), _vm._v(" "), _c('line', {
    staticStyle: {
      "fill": "none",
      "stroke": "#ccc",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "5px"
    },
    attrs: {
      "x1": "274.06",
      "y1": "3.84",
      "x2": "280.66",
      "y2": "3.84"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "hand",
    class: _vm.startSpinning,
    staticStyle: {
      "fill": "#797d83"
    },
    attrs: {
      "d": "M280.25,26.25c.07,2.59-1.2,4.72-2.85,4.77s-3-2-3.11-4.6S277,15.19,277,15.19,280.18,23.66,280.25,26.25Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "ctrlGraphdata"
    }
  }, [_c('line', {
    attrs: {
      "x1": "25",
      "y1": "275",
      "x2": _vm.ctrlGoing.x,
      "y2": _vm.ctrlGoing.y,
      "stroke": "#CC00F0"
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.mixItUp
    }
  }, [_vm._v("Select Variables →")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedSim == true),
      expression: "startedSim == true"
    }],
    key: "sim",
    staticClass: "sim"
  }, [_c('h1', [_vm._v("Variables")]), _vm._v(" "), _c('v-exselect', {
    staticClass: "variables",
    attrs: {
      "options": ['Catalyst', 'Concentration', 'Surface Area', 'Temperature', 'Control'],
      "searchable": false
    },
    model: {
      value: (_vm.reactionVariable),
      callback: function($$v) {
        _vm.reactionVariable = $$v
      },
      expression: "reactionVariable"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons",
    class: _vm.showButtons == true ? 'show' : ''
  }, [_c('button', {
    staticClass: "btn grey",
    class: _vm.increaseOrDecrease == 'decrease' ? 'dark' : '',
    attrs: {
      "disabled": _vm.step === 2
    },
    on: {
      "click": _vm.decrease
    }
  }, [_vm._v("Decrease")]), _vm._v(" "), _c('button', {
    staticClass: "btn grey",
    class: _vm.increaseOrDecrease == 'increase' ? 'dark' : '',
    attrs: {
      "disabled": _vm.step === 2
    },
    on: {
      "click": _vm.increase
    }
  }, [_vm._v("Increase")])]), _vm._v(" "), _c('svg', {
    staticClass: "graph",
    attrs: {
      "width": "300",
      "height": "300",
      "viewBox": "0 0 300 300"
    }
  }, [_c('g', {
    attrs: {
      "id": "graph"
    }
  }, [_c('g', {
    attrs: {
      "id": "labelsnlines"
    }
  }, [_c('text', {
    staticStyle: {
      "transform": "rotate(-90deg)"
    },
    attrs: {
      "x": "-200",
      "y": "10",
      "font-family": "proxima-nova",
      "font-size": "13",
      "fill": "#797d82"
    }
  }, [_vm._v("Amount of Product")]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "140",
      "y": "300",
      "font-family": "proxima-nova",
      "font-size": "13",
      "fill": "#797d82"
    }
  }, [_vm._v("Time")]), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "25",
      "y1": "275",
      "x2": "275",
      "y2": "275",
      "stroke": "#797d82"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "25",
      "y1": "25",
      "x2": "25",
      "y2": "275",
      "stroke": "#797d82"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clock",
    attrs: {
      "cx": "278",
      "cy": "32",
      "r": "21",
      "stroke": "#ccc",
      "stroke-width": "1.8",
      "fill": "#ffffff"
    }
  }), _vm._v(" "), _c('line', {
    staticStyle: {
      "fill": "none",
      "stroke": "#ccc",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "5px"
    },
    attrs: {
      "x1": "274.06",
      "y1": "3.84",
      "x2": "280.66",
      "y2": "3.84"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "hand",
    class: _vm.startSpinning,
    staticStyle: {
      "fill": "#797d83"
    },
    attrs: {
      "d": "M280.25,26.25c.07,2.59-1.2,4.72-2.85,4.77s-3-2-3.11-4.6S277,15.19,277,15.19,280.18,23.66,280.25,26.25Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "graphdata"
    }
  }, [_c('line', {
    attrs: {
      "x1": "25",
      "y1": "275",
      "x2": _vm.going.x,
      "y2": _vm.going.y,
      "stroke": "#CC00F0"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "25",
      "y1": "275",
      "x2": _vm.varGoing.x,
      "y2": _vm.varGoing.y,
      "stroke": "#CC00F0",
      "stroke-width": "2",
      "stroke-dasharray": "4, 8",
      "stroke-linecap": "round"
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: _vm.canRunReaction == false ? 'disabled' : '',
    attrs: {
      "disabled": _vm.canRunReaction == false
    },
    on: {
      "click": _vm.runReaction
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.runReactionLabel)
    }
  })])], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "a"
  }, [_vm._v("A")]), _vm._v(" + "), _c('span', {
    staticClass: "b"
  }, [_vm._v("B")]), _vm._v(" ⟶ "), _c('span', {
    staticClass: "c"
  }, [_vm._v("C")])])
}]}

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('circle', {
    attrs: {
      "cx": _vm.cx,
      "cy": _vm.cy,
      "r": _vm.r,
      "fill": _vm.fill,
      "opacity": _vm.opacity
    }
  })
},staticRenderFns: []}

/***/ })

},[33]);


// WEBPACK FOOTER //
// static/js/app.355db9c0a7ac1b31b99f.js